<template>
  <ion-app>
    <SafeArea
      v-if="layoutsStore.hideHeader"
      class="safe-area"
      position="top"
    />
    <ion-header v-else>
      <Header />
    </ion-header>
    <ion-content>
      <ion-router-outlet />
    </ion-content>
    <SafeArea
      v-if="layoutsStore.hideFooter"
      class="safe-area"
      position="bottom"
    />
    <ion-footer v-else>
      <Footer />
    </ion-footer>
  </ion-app>
</template>

<script
  setup
  lang="ts"
>
import { IonApp, IonContent, IonFooter, IonHeader, IonRouterOutlet } from '@ionic/vue';
import { SafeArea } from '@movinglayers/platforms';
import Footer from './components/layout/Footer.vue';
import Header from './components/layout/Header.vue';
import { useLayoutStore } from './store/layout';

const layoutsStore = useLayoutStore();

</script>

<style>

</style>


<style scoped>
.safe-area {
  --safe-area-background-color: var(--header-footer-background, #ECECEC);
}
</style>